<app-document-templates-nav></app-document-templates-nav>

<div class="capitan-sub-nav-post-content pb-5">

  <div class="pt-3" *ngIf="serverError !== null">
    <h2>Server Error: {{ serverError }}</h2>
  </div>

  <ng-container *ngIf="serverError === null">

    <form (submit)="handleSave()" class="pt-3 pl-md-4 mb-4">

      <app-document-policy-form [(documentPolicy)]="documentPolicy"
                                [documentPolicyErrors]="documentPolicyErrors"></app-document-policy-form>

      <div class="alert alert-danger" role="alert" *ngIf="documentPolicyErrors.non_field_errors">
        {{ documentPolicyErrors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="documentPolicyErrorMessage">
        {{ documentPolicyErrorMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingPolicy">
        Loading...
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="loadingPolicy" [class.disabled]="loadingPolicy">
          Save
        </button>
      </div>
      <button [routerLink]="['/document-policies']"
              [disabled]="loadingPolicy" [class.disabled]="loadingPolicy"
              class="btn btn-secondary">
        Cancel
      </button>

    </form>

  </ng-container>

</div>
